// extracted by mini-css-extract-plugin
export var advancedProductGroup = "style-mod--advanced-product-group--2afc4";
export var box = "style-mod--box--b67b4";
export var cartBtn = "style-mod--cart-btn--e9861";
export var clipStar = "style-mod--clip-star--f2778";
export var container = "style-mod--container--8f3a7";
export var contentCol = "style-mod--content-col--8d9b6";
export var desktopBadge = "style-mod--desktop-badge--85699";
export var freeReturns = "style-mod--free-returns--85c91";
export var imagesCol = "style-mod--images-col--ac0ef";
export var imgBox = "style-mod--img-box--513c1";
export var isDesktop = "style-mod--is-desktop--88a91";
export var isMobile = "style-mod--is-mobile--18370";
export var mobileBadge = "style-mod--mobile-badge--b1453";
export var multiple = "style-mod--multiple--b4638";
export var productPrice = "style-mod--product-price--37110";
export var productTitle = "style-mod--product-title--5b1aa";
export var ratingText = "style-mod--rating-text--ea62d";
export var selected = "style-mod--selected--c17b3";
export var singleProduct = "style-mod--single-product--c49e2";
export var singleProductContent = "style-mod--single-product-content--34432";
export var tooltipInfo = "style-mod--tooltip-info--f0a1b";